export default __webpack_public_path__ + "static/pic2-c738e729f7b8ef8f1752e47ca29c0ed6.png";